module.exports = __webpack_public_path__ + "static/media/dot-dark.07afe0ba.svg";